module.exports = __webpack_public_path__ + "media/32.e0ded3a6.mp3";